import { Auth } from '@mabinso-registry/module-commons';


export default Auth;
